import styled from 'styled-components';
import { Text } from '@rsos/components/capstone/base';

export const Description = styled(Text).attrs({
  size: 'normal',
  color: 'secondaryText',
  inline: true,
  my: 25,
  textAlign: 'center',
  px: 75,
})``;
